import React from "react";
import "./SustainabilitySection.css";

function SustainabilitySection() {
  return (
    <section className="sustainability">

      <div className="sustainability-container">

        {/* LEFT CONTENT */}
        <div className="sustainability-text">
          <h2>Corporate Responsibility & Sustainability</h2>

          <p>
            Relyonneuk is dedicated to sustainable business practices, ensuring that all materials
            are sourced through responsible and certified supply chains. We prioritize partnerships
            that uphold environmental integrity and ethical standards.
          </p>

          <p>
            With a strong commitment to reducing environmental impact, we continuously innovate to
            improve efficiency, minimize waste, and lower carbon emissions, contributing to a more
            sustainable future for the industry and the communities we serve.
          </p>
        </div>

        {/* RIGHT IMAGE */}
        <div className="sustainability-image">
          <img src="/Sustainability.png" alt="sustainability" />
        </div>

      </div>

    </section>
  );
}

export default SustainabilitySection;